// import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

import { useEffect, useState } from "react";

/* -------- COMMON USER ID HELPER -------- */
const getMyId = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decoded = JSON.parse(atob(token.split(".")[1]));
    return (decoded.userId || decoded.id)?.toString();
  } catch {
    return null;
  }
};

function ChatList() {
  const [conversations, setConversations] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const myId = getMyId();

  /* ---------------- DELETE CHAT ---------------- */
  const handleDelete = async (e, conversationId) => {
    e.stopPropagation();

    if (!window.confirm("Delete this chat?")) return;

    await fetch(
      ` https://borrowhub-backend.onrender.com/api/chat/conversation/${conversationId}`,
      {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setConversations((prev) =>
      prev.filter((c) => c._id !== conversationId)
    );
  };

  /* ---------------- FETCH CHATS ---------------- */
  useEffect(() => {
    const fetchChats = async () => {
      const res = await fetch(
        "https://borrowhub-backend.onrender.com/api/chat/conversations",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!res.ok) return;

      const data = await res.json();
      setConversations(data);
    };

    if (token) fetchChats();
  }, [token]);

  return (
    <>
      <Navbar />

      <div className="container mt-4">
        <h4 className="fw-bold mb-3">Chats</h4>

        {conversations.map((c) => {
          const otherUser = c.participants.find(
            (p) => (p._id || p).toString() !== myId
          );

          return (
            <div
              key={c._id}
              className="card p-3 mb-2 d-flex flex-row justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/chat/${c._id}`)}
            >
              {/* LEFT */}
              <div className="d-flex align-items-center gap-3">
                <img
                  src={c.item?.images?.[0]?.url}
                  alt=""
                  width={50}
                  height={50}
                  style={{ objectFit: "cover", borderRadius: 6 }}
                />

                <div>
                  <div className="fw-semibold">
                    {otherUser?.name || "User"}
                  </div>
                  <small className="text-muted">
                    {c.item?.title}
                  </small>
                </div>
              </div>

              {/* RIGHT */}
              <button
                className="btn btn-sm btn-danger"
                onClick={(e) => handleDelete(e, c._id)}
              >
                Delete
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default ChatList;
